import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { Dispatch, FC, SetStateAction } from 'react'

interface DeleteConfirmationDialogProps {
  confirmOpen: boolean
  setConfirmOpen: Dispatch<SetStateAction<boolean>>
  onDeleteEntireList: () => void
  isDeleting: boolean
}
const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  confirmOpen,
  setConfirmOpen,
  onDeleteEntireList,
  isDeleting,
}) => {
  return (
    <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
      <DialogTitle>Delete entire task list?</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          This will remove the current checklist from this organization. You can re-create from a template later.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setConfirmOpen(false)}>Cancel</Button>
        <Button color="error" variant="contained" onClick={onDeleteEntireList} disabled={isDeleting}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}
export default DeleteConfirmationDialog
